import { Shortcut } from "./ShortcutsBar";

export const defaultShortcuts: Shortcut[] = [
  // 📂 Dateien & Verzeichnisse
  { label: "Inhalte im aktuellen Pfad anzeigen", command: "ls -la\r" },

  {
    label: "In Home-Verzeichnis wechseln",
    command: "cd ~\r",
  },

  {
    label: "Datei nach Namen suchen",
    command:
      'echo; read -p "Dateiname oder Muster: " name; ' +
      'if [ -z "$name" ]; then echo "Fehler: Kein Suchbegriff angegeben"; ' +
      'else find -H ~ -type f -name "*$name*" 2>/dev/null || echo "Nichts gefunden"; fi\r',
    isLongRunning: true,
  },

  {
    label: "Größte Dateien anzeigen",
    command:
      "out=$(find -H ~ -type f -exec du -k {} + 2>/dev/null | sort -nr | head -n 20); " +
      'if [ -z "$out" ]; then echo "Nichts gefunden"; else printf "%s\n" "$out" | while read size path; do du -h "$path"; done; fi\r',
  },

  {
    label: "Archive entpacken in Zielordner",
    command:
      'echo; read -p "Pfad zur Archiv-Datei: " file; ' +
      'read -p "Zielordner (Enter für aktuelles): " dest; dest="${dest:-.}"; ' +
      'if [ -z "$file" ]; then echo "Fehler: Kein Dateiname angegeben"; ' +
      'elif [ ! -f "$file" ]; then echo "Fehler: Datei nicht gefunden"; ' +
      'else mkdir -p "$dest" && ' +
      'case "$file" in ' +
      '*.tar.gz) tar -xzf "$file" -C "$dest" || echo "Fehler: Entpacken fehlgeschlagen" ;; ' +
      '*.tar.bz2|*.tbz2) tar -xjf "$file" -C "$dest" || echo "Fehler: Entpacken fehlgeschlagen" ;; ' +
      '*.tar.xz) tar -xJf "$file" -C "$dest" || echo "Fehler: Entpacken fehlgeschlagen" ;; ' +
      '*.zip) unzip "$file" -d "$dest" || echo "Fehler: Entpacken fehlgeschlagen" ;; ' +
      '*) echo "Fehler: Format nicht unterstützt (.tar.gz, .tar.bz2, .tar.xz, .zip)" ;; ' +
      "esac; fi\r",
    isLongRunning: true,
  },

  {
    label: "Ordner als tar.gz sichern",
    command:
      'echo; read -p "Pfad zum Ordner (Enter für aktuelles Verzeichnis): " dir; ' +
      'dir="${dir:-.}"; ' +
      'if [ ! -d "$dir" ]; then echo "Fehler: Ordner nicht gefunden"; ' +
      'else file="$(basename "$dir")_$(date +%F_%H-%M-%S).tar.gz"; ' +
      'tar -czf "$file" "$dir" && echo "Archiv erstellt: $file" || echo "Fehler: Sicherung fehlgeschlagen"; fi\r',
    isLongRunning: true,
  },

  {
    label: "Datei herunterladen (wget)",
    command:
      'echo; read -p "Datei-URL: " url; ' +
      'if [ -z "$url" ]; then echo "Fehler: Keine URL angegeben"; ' +
      'else wget "$url" || echo "Fehler: Download fehlgeschlagen"; fi\r',
    isLongRunning: true,
  },

  // 📜 Logs
  {
    label: "Access-Log (live) anzeigen",
    command: "tail -f -n 50 /logs/http/access.log\r",
    isLongRunning: true,
  },

  {
    label: "Access-Log nach IP filtern",
    command:
      'echo; read -p "IP-Adresse eingeben: " ip; ' +
      'if [ -z "$ip" ]; then echo "Fehler: Keine IP angegeben"; ' +
      'else grep "$ip" /logs/http/access.log || echo "Nichts gefunden"; fi\r',
    isLongRunning: true,
  },

  {
    label: "Top 10 IPs im Access-Log anzeigen",
    command:
      'if [ ! -f /logs/http/access.log ]; then echo "Fehler: Access-Log nicht gefunden"; ' +
      "else out=$(awk '{print $1}' /logs/http/access.log 2>/dev/null | LC_ALL=C sort | uniq -c | sort -nr | head -n 10); " +
      'if [ -z "$out" ]; then echo "Nichts gefunden"; else printf "%s\\n" "$out"; fi; fi\r',
  },

  {
    label: "5xx-Fehler im Access-Log anzeigen",
    command:
      "if [ ! -f /logs/http/access.log ]; then " +
      'echo "Fehler: Access-Log nicht gefunden"; ' +
      "else " +
      "awk '{ if ($9 ~ /^5[0-9][0-9]$/) { print; found=1 } } END { if (!found) print \"Keine 5xx-Fehler gefunden\" }' /logs/http/access.log; " +
      "fi\r",
  },

  // 🐘 PHP
  {
    label: "PHP-Dateien nach Inhalt durchsuchen",
    command:
      'echo; read -p "Suchbegriff eingeben: " term; ' +
      'if [ -z "$term" ]; then echo "Fehler: Kein Suchbegriff angegeben"; ' +
      'else grep -Rni --include="*.php" "$term" . || echo "Nichts gefunden"; fi\r',
    isLongRunning: true,
  },

  { label: "PHP-OPCache leeren", command: "touch /etc/php/php.ini\r" },

  {
    label: "PHP-Info-Datei erstellen",
    command:
      'if [ -f phpinfo.php ]; then echo "Fehler: phpinfo.php existiert bereits"; ' +
      'else echo "<?php phpinfo();" > phpinfo.php && echo "Datei phpinfo.php erstellt"; fi\r',
  },

  // 🗄️ MySQL
  {
    label: "MySQL-Dump erstellen",
    command:
      'echo; read -p "Benutzername: " user; ' +
      'read -s -p "Passwort: " pass; echo; ' +
      'read -p "Hostname: " host; ' +
      'read -p "Datenbankname: " db; ' +
      'if [ -z "$user" ] || [ -z "$pass" ] || [ -z "$host" ] || [ -z "$db" ]; then echo "Fehler: Alle Felder müssen ausgefüllt werden"; ' +
      'else file="${db}_$(date +%F_%H-%M-%S).sql"; ' +
      'mysqldump -u "$user" -p"$pass" -h "$host" "$db" > "$file" && echo "Dump erstellt: $file" || echo "Fehler: Dump fehlgeschlagen"; fi\r',
    isLongRunning: true,
  },

  {
    label: "MySQL-Dump importieren",
    command:
      'echo; read -p "Benutzername: " user; ' +
      'read -s -p "Passwort: " pass; echo; ' +
      'read -p "Hostname: " host; ' +
      'read -p "Zieldatenbank: " db; ' +
      'read -p "Pfad zur SQL-Datei: " file; ' +
      'if [ -z "$user" ] || [ -z "$pass" ] || [ -z "$host" ] || [ -z "$db" ] || [ -z "$file" ]; then echo "Fehler: Alle Felder müssen ausgefüllt werden"; ' +
      'elif [ ! -f "$file" ]; then echo "Fehler: Datei nicht gefunden"; ' +
      'else mysql -u "$user" -p"$pass" -h "$host" "$db" < "$file" || echo "Fehler: Import fehlgeschlagen"; fi\r',
    isLongRunning: true,
  },
];
